import * as Feather from 'react-feather';
import { Button } from "reactstrap";
import { canPerform, canView } from "../../../../fgs/helpers/Authorization";

const PAGE = 'DocumentListPage';

const toolbarActions = [
  {
    component: Button,
    props: {
      name: 'filter',
      color: 'secondary',
      className: 'mr-1'
    },
    text: '',
    icon: Feather.Filter,
    canPerform: () => canView(PAGE)
  },
  {
    component: Button,
    props: {
      name: 'download',
      color: 'primary',
      className: 'mr-1',
    },
    text: '',
    icon: Feather.Download,
    canPerform: () => canPerform(PAGE, 'download')
  },
  {
    component: Button,
    props: {
      name: 'remove',
      color: 'danger',
      className: 'mr-1',
    },
    text: '',
    icon: Feather.Trash,
    canPerform: () => canPerform(PAGE, 'remove')
  },
  {
    component: Button,
    props: {
      name: 'add',
      color: 'success'
    },
    text: '',
    icon: Feather.FolderPlus,
    canPerform: () => canPerform(PAGE, 'add_folder')
  },
];

export default toolbarActions;